export default function getComplexityPreferenceLabel(complexity_preference?: number): string {
  switch (complexity_preference) {
    case undefined:
      return "--"
    case 0:
      return 'Quick and easy';
    case 1:
      return 'Quick and easy';
    case 2:
      return "Moderate"
    case 3:
      return 'Moderate';
    case 4:
      return 'Fancy meals';
    default:
      return "Unknown"
  }
}
